import { render, staticRenderFns } from "./TestPayments.vue?vue&type=template&id=3fb47c44&scoped=true"
import script from "./TestPayments.vue?vue&type=script&lang=js"
export * from "./TestPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb47c44",
  null
  
)

export default component.exports